var _rect, _text, _text2, _rect2, _rect3, _text3, _path, _polygon, _rect4, _text4, _path2, _polygon2, _rect5, _text5, _text6, _text7, _rect6, _rect7, _text8, _path3, _polygon3, _rect8, _text9, _path4, _polygon4, _rect9, _text10, _path5, _polygon5, _rect10, _text11, _path6, _polygon6, _rect11, _text12, _path7, _polygon7, _rect12, _text13, _path8, _polygon8, _rect13, _text14, _path9, _polygon9, _rect14, _text15, _text16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg04HarnessWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 420",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 420,
    fill: "#fafafa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 34,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Same Request. Different Reliability.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 70,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Without harness")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 400,
    height: 70,
    rx: 12,
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 108,
    width: 70,
    height: 34,
    rx: 7,
    fill: "#f3f4f6",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 130,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "User")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 125 L165 125",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "169,125 159,119 159,131",
    fill: "#111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 108,
    width: 70,
    height: 34,
    rx: 7,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 130,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Model")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 125 L280 125",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "284,125 274,119 274,131",
    fill: "#111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 108,
    width: 120,
    height: 34,
    rx: 7,
    fill: "#fef3c7",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 130,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Generated code")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 190,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Hope it works. No tests. No validation.")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 240,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "With harness")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 260,
    width: 880,
    height: 120,
    rx: 12,
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 295,
    width: 70,
    height: 40,
    rx: 7,
    fill: "#f3f4f6",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "User")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 315 L148 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "152,315 142,309 142,321",
    fill: "#111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 295,
    width: 78,
    height: 40,
    rx: 7,
    fill: "#e0e7ff",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Planner")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241 315 L259 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "263,315 253,309 253,321",
    fill: "#111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 295,
    width: 70,
    height: 40,
    rx: 7,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Model")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344 315 L362 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "366,315 356,309 356,321",
    fill: "#111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 295,
    width: 78,
    height: 40,
    rx: 7,
    fill: "#bfdbfe",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 411,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Code gen")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M455 315 L473 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "477,315 467,309 467,321",
    fill: "#111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 295,
    width: 78,
    height: 40,
    rx: 7,
    fill: "#bbf7d0",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 522,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Tests")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M566 315 L584 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "588,315 578,309 578,321",
    fill: "#111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 295,
    width: 78,
    height: 40,
    rx: 7,
    fill: "#fce7f3",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 633,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Fix loop")), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M677 315 L695 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "699,315 689,309 689,321",
    fill: "#111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 295,
    width: 78,
    height: 40,
    rx: 7,
    fill: "#fef3c7",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 744,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Review")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M788 315 L806 315",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "810,315 800,309 800,321",
    fill: "#111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 816,
    y: 295,
    width: 80,
    height: 40,
    rx: 7,
    fill: "#d1fae5",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 856,
    y: 320,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Ship")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 400,
    textAnchor: "middle",
    fill: "#555",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Failures become feedback. Output is verified before delivery.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04HarnessWorkflow);
export default __webpack_public_path__ + "static/media/04-harness-workflow.d8bae10d73d767d61446eeffae4c3d3b.svg";
export { ForwardRef as ReactComponent };